import React, { useState, useCallback, useEffect, useMemo } from 'react';
import Button from '@msi/cobalt-react/button';
import { Modal, ModalHeader, ModalContent, ModalActions } from '@msi/cobalt-react/modal';
import ReactMarkdown from 'react-markdown';
import { useModalManager } from '../ModalManager/ModalManager';
import './ReleaseNotesModal.css';
import { getMajorVersion } from '../../helpers/VersionManager';

const ReleaseNotesModal: React.FC = () => {
    const { currentModalId, acknowledgeModal } = useModalManager();
    const [show, setShow] = useState(false);
    const [releaseNotesContent, setReleaseNotesContent] = useState<string>('');

    const getReleaseNotesFileName = (): string => {
        const majorVersion = getMajorVersion();
        const fileName = `release-v${majorVersion}.md`;
        return fileName;
    };

    useEffect(() => {
        const shouldShow = currentModalId === 'releaseNotes';

        if (shouldShow && !releaseNotesContent) {
            const fileName = getReleaseNotesFileName();
            // Fetch the markdown file from public folder with specific Accept header
            fetch(`/release-notes/${fileName}`, {
                headers: {
                    'Accept': 'text/markdown'
                }
            })
            .then((response) => {
                const contentType = response.headers.get('Content-type');
                console.log('🔍 Release Notes Debug - Content-Type:', contentType);
                if (response.ok && (contentType?.includes('text/markdown') || contentType?.includes('text/plain'))) {
                    return response.text();
                }
                throw new Error(`Failed to load release notes: ${fileName} (Status: ${response.status}, Content-Type: ${contentType})`);
            })
            .then((content) => {
                setReleaseNotesContent(content);
                setShow(true);
            })
            .catch((error) => {
                console.warn('Release notes not available:', error.message);
            });
            
        } else if (shouldShow && releaseNotesContent) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [currentModalId, releaseNotesContent, acknowledgeModal]);

    const onClose = useCallback(() => {
        setShow(false);
        acknowledgeModal('releaseNotes');
    }, [acknowledgeModal]);

    const modalStyle = useMemo(() => ({
        overlay: { zIndex: 10000 },
        content: { zIndex: 10001 },
    }), []);

    return (
        show && releaseNotesContent ? (
            <Modal handleCloseModal={onClose} showModal={show} style={modalStyle}>
                <ModalHeader>What's New in API Hub</ModalHeader>
                <ModalContent>
                    <div className="release-notes-content">
                        <ReactMarkdown>{releaseNotesContent}</ReactMarkdown>
                    </div>
                </ModalContent>
                <ModalActions>
                    <Button text="Got it!" onClick={onClose} variant="primary" />
                </ModalActions>
            </Modal>
        ) : null
    );
};

export default ReleaseNotesModal;
